import type { TeamsApi } from "@/v2/api/metadata/teams";
import type { DialogConfig } from "@/v2/framework/dialog/types";
import { notify, notifyApiError } from "@/v2/notifications/notify";
import { NXGDSStatusVariant } from "@nsftx/seven-nxg-design-system-backoffice";

export function createDeleteDialog(options: { teamsApi: TeamsApi }): DialogConfig {
  const { teamsApi } = options;

  return {
    id: "delete-team",
    title: "Delete team",
    description: "Are you sure you want to delete this team?",
    layout: {
      type: "nxgds-dialog",
      actions: [
        { intent: "dismiss", label: "Cancel", variant: "secondary" },
        { intent: "submit", label: "Delete", variant: "danger" },
      ],
    },
    structure: { type: "flat", children: [] },
    api: {
      submit: async (_data, dialogCtx) => {
        try {
          await teamsApi.delete(dialogCtx.row?.id);
          notify({
            variant: NXGDSStatusVariant.Positive,
            text: `You have successfully deleted "${dialogCtx.row?.name}" team.`,
          });
        } catch (error) {
          notifyApiError(error, `Unable to delete "${dialogCtx.row?.name}" team.`);
        }
      },
    },
  };
}
